import { useCallback } from 'react';

import { BuyerAuthSlideout, SellerAuthSlideout } from 'components/common/AuthSlideout';
import { useBezelUser } from 'context/bezelUser';
import { useModal } from 'context/modal/ModalContext';
import { PurchaseRequest, PurchaseRequestOffer } from 'types';

import { RequestDescriptionSlideout } from './Slideouts/RequestDescriptionSlideout';

export const useHandleRequest = (
  purchaseRequest: PurchaseRequest | undefined,
  requestOffers?: PurchaseRequestOffer[]
) => {
  const { user } = useBezelUser();
  const { closeModal, openModal } = useModal();

  const onRespond = useCallback(() => {
    if (!purchaseRequest) {
      return;
    }

    if (!!user?.sellerProfile && user.sellerProfile.live) {
      openModal(
        <RequestDescriptionSlideout
          purchaseRequest={purchaseRequest}
          requestOffers={requestOffers}
          closeModal={closeModal}
        />,
        true
      );
    } else if (user) {
      openModal(<SellerAuthSlideout closeModal={closeModal} />, true);
    } else {
      openModal(<BuyerAuthSlideout closeModal={closeModal} />, true);
    }
  }, [closeModal, openModal, purchaseRequest, requestOffers, user]);

  return { onRespond };
};
